import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Edit } from "lucide-react";
import Layout from "./layout";
import { userManagementData } from "../data/userManagementMockData";
import UserManagementModal from "../Modal/UserManagementModal";
import EditUserManagementModal from "../Modal/EditUserManagementModal";
import { consultantAPI } from "../services/api";

const PageContainer = styled.div`
  font-family: "Prompt", sans-serif;
  background-color: #ffffff;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
`;

const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const FilterLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #686868;
  min-width: 120px;
`;

const FilterInput = styled.input`
  padding: 0.4rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 12px;
  font-family: "Prompt", sans-serif;
  width: 160px;

  &:focus {
    outline: none;
    border-color: #00b5b8;
    box-shadow: 0 0 0 3px rgba(0, 181, 184, 0.1);
  }
`;

const CheckboxGroup = styled.div`
  display: inline-flex;
  gap: 1rem;
  align-items: center;
`;

const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 12px;
  font-weight: 400;
  color: #686868;
  cursor: pointer;
  white-space: nowrap;
  min-width: fit-content;
`;

const Checkbox = styled.input`
  width: 0.875rem;
  height: 0.875rem;
  accent-color: #00b5b8;
  cursor: pointer;
`;

const SearchLabel = styled.label`
  font-size: 12px;
  font-weight: 400;
  color: #686868;
  white-space: nowrap;
`;

const SearchInput = styled.input`
  padding: 0.4rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 12px;
  font-family: "Prompt", sans-serif;

  &:focus {
    outline: none;
    border-color: #00b5b8;
    box-shadow: 0 0 0 3px rgba(0, 181, 184, 0.1);
  }
`;

const SearchButton = styled.button`
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 0.375rem;
  padding: 0.4rem 1.5rem;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  font-family: "Prompt", sans-serif;

  &:hover {
    background-color: #1f2937;
  }
`;

const CreateButton = styled.button`
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Prompt", sans-serif;
  white-space: nowrap;

  &:hover {
    background-color: #1f2937;
  }
`;

const TableWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9fafb;
  }
`;

const TableHeaderCell = styled.th`
  padding: 0.5rem 0.3rem;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #a3a3a3;
`;

const TableCell = styled.td`
  padding: 0.5rem 0.3rem;
  font-size: 12px;
  text-align: center;
  font-weight: 400;
  color: #686868;
`;

const CampaignBadge = styled.span`
  background-color: #1d87f0;
  color: #ffffff;
  padding: 0.2rem 0.5rem;
  border-radius: 0px;
  font-size: 11px;
  font-weight: 400;
  display: inline-block;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.3rem;
  border-radius: 0.25rem;
  color: #1d87f0;

  &:hover {
    background-color: #f3f4f6;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const PaginationButton = styled.button`
  padding: 0.4rem 0.6rem;
  border: none;
  background-color: ${(props) => (props.active ? "#1976D2" : "transparent")};
  color: ${(props) => (props.active ? "white" : "#1976D2")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  font-size: 0.75rem;
  font-family: "Prompt", sans-serif;
  min-width: 35px;
  text-decoration: ${(props) => (props.active ? "none" : "underline")};

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
  }
`;

const UserManagementPage = () => {
  const [filters, setFilters] = useState({
    หมอ: false,
    // นักกำหนดอาหาร: false,
    // เภสัชกร: false,
    พยาบาล: false,
    // พยาบาลวิชาชีพ: false,
    // นักวิชาการสาธารณสุข: false,
    // ผู้ให้ความรู้โรคเบาหวาน: false,
    // ผู้เชี่ยวชาญด้านการออกกำลังกาย: false,
    // นักกายภาพบำบัด: false,
    เจ้าหน้าที่อื่น: false,
    manager: false,
    analyze: false,
    // ฯลฯ: false
  });

  const [searchName, setSearchName] = useState("");
  const [searchField, setSearchField] = useState("");
  const [searchCompany, setSearchCompany] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingConsultant, setEditingConsultant] = useState(null);
  const [consultants, setConsultants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const itemsPerPage = 20;

  // ดึงข้อมูลที่ปรึกษาจาก API
  useEffect(() => {
    fetchConsultants();
  }, []);

  // Scroll to top เมื่อเปลี่ยนหน้า
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  const fetchConsultants = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await consultantAPI.getList();

      console.log("🔍 fetchConsultants - Raw API Response:", response);

      // API ส่งกลับมาในรูปแบบ { result: true/false, list: [...] }
      // หรือ { result: false, responseText: "ไม่พบรายการ" }
      if (response.list && Array.isArray(response.list)) {
        // ถ้ามี list ให้ใช้ list (ไม่สนใจว่า result จะเป็น true หรือ false)
        const mappedConsultants = response.list.map((consultant) => {
          // สร้างชื่อแบบไม่ซ้ำ โดยรวม nameprefix, name, lastname และกรองค่าว่างออก
          const nameParts = [
            consultant.nameprefix,
            consultant.name,
            consultant.lastname,
          ].filter((part) => part && part.trim() !== ""); // กรองเฉพาะค่าที่มีข้อมูล

          const fullName = nameParts.join(" ").trim() || "-";

          // ตรวจสอบ role จาก consultant.role array
          const roles = consultant.role || [];
          const isAdminDoctor = Array.isArray(roles)
            ? roles.includes("admin_doctor")
            : consultant.isAdminDoctor || false;

          return {
            // ข้อมูลดิบจาก API (สำหรับการแก้ไข)
            ...consultant,
            // ข้อมูลที่ map สำหรับแสดงในตาราง
            id: consultant.id,
            code: consultant.id, // API ไม่มี code ใช้ id แทน
            username: consultant.username || "-",
            displayName: fullName, // ใช้ displayName แทน name เพื่อไม่ให้ overwrite
            isSuperAdmin: consultant.level === "1", // level 1 = super admin
            isAdminDoctor: isAdminDoctor, // ดึงจาก role array
            type: consultant.typeconsult || consultant.position || "หมอ",
            field: consultant.typebranch || consultant.job || "-",
            company: "-", // API ไม่ส่งข้อมูลบริษัทมา
            campaign:
              consultant.consultCampaign &&
              consultant.consultCampaign.length > 0
                ? consultant.consultCampaign[0].name
                : "-",
          };
        });
        console.log("✅ Mapped consultants:", mappedConsultants);
        setConsultants(mappedConsultants);
      } else if (response.result === false && response.responseText) {
        // กรณี API ส่งกลับมาว่า result: false และมี responseText
        console.warn("⚠️ API returned no data:", response.responseText);
        setConsultants([]); // แสดงตารางว่าง
      } else if (response.data && Array.isArray(response.data)) {
        setConsultants(response.data);
      } else if (Array.isArray(response)) {
        setConsultants(response);
      } else {
        // ถ้า API ส่งรูปแบบไม่ตรง แสดงตารางว่าง
        console.warn("⚠️ API response format unknown:", response);
        setConsultants([]);
      }
    } catch (err) {
      console.error("❌ Error fetching consultants:", err);
      setError(err.message);
      // ถ้า API error แสดงตารางว่าง
      setConsultants([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (filterName) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: !prev[filterName],
    }));
  };

  const handleSaveModal = async (data) => {
    try {
      // เพิ่มที่ปรึกษาใหม่
      await consultantAPI.add(data);
      fetchConsultants(); // รีเฟรชข้อมูล
      setIsModalOpen(false);
    } catch (err) {
      console.error("Error saving consultant:", err);
      setError("เกิดข้อผิดพลาดในการบันทึกข้อมูล: " + err.message);
    }
  };

  const handleUpdateConsultant = async (data) => {
    try {
      const response = await consultantAPI.update(data);

      if (response.result) {
        await fetchConsultants();
        setIsEditModalOpen(false);
        setEditingConsultant(null);
        alert("บันทึกข้อมูลสำเร็จ");
      } else {
        const errorMsg =
          response.responseText || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
        setError(errorMsg);
        alert(errorMsg);
      }
    } catch (err) {
      console.error("Error updating consultant:", err);
      setError("เกิดข้อผิดพลาดในการอัพเดทข้อมูล: " + err.message);
      alert("เกิดข้อผิดพลาดในการอัพเดทข้อมูล: " + err.message);
    }
  };

  const handleEditConsultant = (consultant) => {
    // ต้องดึงข้อมูลเต็มจาก API ก่อน เพราะตาราง mapping ไว้ไม่ครบ
    // แต่ถ้า API ส่งข้อมูลครบมาแล้ว ก็ใช้ข้อมูลจาก consultant ได้เลย
    console.log(
      "🔍 UserManagement - Opening edit modal for consultant:",
      consultant
    );
    setEditingConsultant(consultant);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setEditingConsultant(null);
  };

  const handleSearch = async () => {
    setLoading(true);
    setCurrentPage(1); // รีเซ็ตกลับไปหน้า 1 เมื่อค้นหา
    try {
      // สร้าง filter object สำหรับส่งไป API (ConsultList)
      const searchFilters = {};

      // ค้นหาจากชื่อ-สกุล
      if (searchName) searchFilters.keywordName = searchName;

      // ส่ง filter ประเภทที่เลือก (หมอ, นักกำหนดอาหาร, ฯลฯ)
      const selectedTypes = Object.keys(filters).filter((key) => filters[key]);
      if (
        selectedTypes.length > 0 &&
        selectedTypes.length < Object.keys(filters).length
      ) {
        searchFilters.types = selectedTypes;
      }

      const response = await consultantAPI.getList(searchFilters);

      console.log("🔍 handleSearch - Raw API Response:", response);
      console.log("🔍 Selected filters:", selectedTypes);

      // API ส่งกลับมาในรูปแบบ { result: true/false, list: [...] }
      if (response.list && Array.isArray(response.list)) {
        // ถ้ามี list ให้ใช้ list (ไม่สนใจว่า result จะเป็น true หรือ false)
        let mappedConsultants = response.list.map((consultant) => {
          // สร้างชื่อแบบไม่ซ้ำ โดยรวม nameprefix, name, lastname และกรองค่าว่างออก
          const nameParts = [
            consultant.nameprefix,
            consultant.name,
            consultant.lastname,
          ].filter((part) => part && part.trim() !== ""); // กรองเฉพาะค่าที่มีข้อมูล

          const fullName = nameParts.join(" ").trim() || "-";

          // ตรวจสอบ role จาก consultant.role array
          const roles = consultant.role || [];
          const isAdminDoctor = Array.isArray(roles)
            ? roles.includes("admin_doctor")
            : consultant.isAdminDoctor || false;

          return {
            // ข้อมูลดิบจาก API (สำหรับการแก้ไข)
            ...consultant,
            // ข้อมูลที่ map สำหรับแสดงในตาราง
            id: consultant.id,
            code: consultant.id, // API ไม่มี code ใช้ id แทน
            username: consultant.username || "-",
            displayName: fullName, // ใช้ displayName แทน name เพื่อไม่ให้ overwrite
            isSuperAdmin: consultant.level === "1", // level 1 = super admin
            isAdminDoctor: isAdminDoctor, // ดึงจาก role array
            type: consultant.typeconsult || consultant.position || "หมอ",
            field: consultant.typebranch || consultant.job || "-",
            company: "-", // API ไม่ส่งข้อมูลบริษัทมา
            campaign:
              consultant.consultCampaign &&
              consultant.consultCampaign.length > 0
                ? consultant.consultCampaign[0].name
                : "-",
          };
        });

        // กรองข้อมูลตาม checkbox ที่เลือก (client-side filtering)
        if (selectedTypes.length > 0) {
          mappedConsultants = mappedConsultants.filter((consultant) => {
            // ดึง role array จาก consultant
            const consultantRoles = consultant.role || [];

            // ตรวจสอบว่า consultant.type ตรงกับ checkbox ที่เลือกหรือไม่
            return selectedTypes.some((selectedType) => {
              // จับคู่ประเภทที่เลือกกับ type ในข้อมูล
              if (selectedType === "หมอ") {
                return (
                  consultant.type === "หมอ" || consultant.type === "doctor"
                );
              } else if (selectedType === "พยาบาล") {
                return (
                  consultant.type === "พยาบาล" || consultant.type === "nurse"
                );
              } else if (selectedType === "manager") {
                return (
                  consultant.type === "manager" ||
                  (Array.isArray(consultantRoles) &&
                    consultantRoles.includes("manager"))
                );
              } else if (selectedType === "analyze") {
                return (
                  consultant.type === "analyze" ||
                  (Array.isArray(consultantRoles) &&
                    consultantRoles.includes("analyze"))
                );
              } else if (selectedType === "เจ้าหน้าที่อื่น") {
                return (
                  consultant.type === "เจ้าหน้าที่อื่น" ||
                  consultant.type === "other"
                );
              }
              return consultant.type === selectedType;
            });
          });
        }

        console.log("✅ Search results (after filtering):", mappedConsultants);
        setConsultants(mappedConsultants);
      } else if (response.result === false && response.responseText) {
        console.warn("⚠️ API returned no data:", response.responseText);
        setConsultants([]);
      } else if (response.data && Array.isArray(response.data)) {
        setConsultants(response.data);
      } else if (Array.isArray(response)) {
        setConsultants(response);
      } else {
        console.warn("⚠️ API response format unknown:", response);
        setConsultants([]);
      }
    } catch (err) {
      console.error("❌ Error searching consultants:", err);
      setError(err.message);
      setConsultants([]);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(consultants.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = consultants.slice(startIndex, endIndex);

  return (
    <Layout>
      <PageContainer>
        {/* Loading & Error States */}
        {loading && (
          <div
            style={{ textAlign: "center", padding: "1rem", fontSize: "12px" }}
          >
            กำลังโหลดข้อมูล...
          </div>
        )}
        {error && (
          <div
            style={{
              textAlign: "center",
              padding: "1rem",
              color: "#EF4444",
              fontSize: "12px",
            }}
          >
            เกิดข้อผิดพลาด: {error}
          </div>
        )}

        <HeaderSection>
          <ButtonRow>
            <CreateButton onClick={() => setIsModalOpen(true)}>
              เพิ่มที่ปรึกษา
            </CreateButton>
          </ButtonRow>

          <FilterRow>
            <FilterGroup>
              <FilterLabel>ค้นหาจาก ชื่อ หรือ นามสกุล</FilterLabel>
              <FilterInput
                type="text"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
              <FilterLabel style={{ marginLeft: "1rem" }}>ประเภท</FilterLabel>
              <CheckboxGroup>
                {Object.keys(filters).map((filter) => (
                  <CheckboxLabel key={filter}>
                    <Checkbox
                      type="checkbox"
                      checked={filters[filter]}
                      onChange={() => handleFilterChange(filter)}
                    />
                    {filter}
                  </CheckboxLabel>
                ))}
              </CheckboxGroup>
            </FilterGroup>
            <SearchButton onClick={handleSearch}>ค้นหา</SearchButton>
          </FilterRow>
        </HeaderSection>

        <PaginationContainer>
          <PaginationButton
            onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            previous
          </PaginationButton>
          {[...Array(totalPages)].map((_, index) => (
            <PaginationButton
              key={index + 1}
              active={currentPage === index + 1}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </PaginationButton>
          ))}
          <PaginationButton
            onClick={() =>
              setCurrentPage((prev) => Math.min(totalPages, prev + 1))
            }
            disabled={currentPage === totalPages}
          >
            next
          </PaginationButton>
        </PaginationContainer>

        <TableWrapper>
          <Table>
            <TableHeader>
              <tr>
                <TableHeaderCell>ลำดับ</TableHeaderCell>
                <TableHeaderCell>รหัสที่ปรึกษา</TableHeaderCell>
                <TableHeaderCell>ชื่อ-สกุล</TableHeaderCell>
                <TableHeaderCell>admin doctor</TableHeaderCell>
                <TableHeaderCell>super admin</TableHeaderCell>
                <TableHeaderCell>พยาบาล</TableHeaderCell>
                <TableHeaderCell>manager</TableHeaderCell>
                <TableHeaderCell>analyze</TableHeaderCell>
                <TableHeaderCell>ประเภท</TableHeaderCell>
                {/* <TableHeaderCell>สาขา</TableHeaderCell> */}
                <TableHeaderCell>แก้ไข</TableHeaderCell>
              </tr>
            </TableHeader>
            <tbody>
              {currentData.map((user, index) => {
                // ตรวจสอบ role array
                const roles = user.role || [];
                const isNurse =
                  roles.includes("nurse") || user.type === "พยาบาล";
                const isManager = roles.includes("manager");
                const isAnalyze = roles.includes("analyze");

                return (
                  <TableRow key={user.id}>
                    <TableCell>{startIndex + index + 1}</TableCell>
                    <TableCell>{user.code}</TableCell>
                    <TableCell>{user.displayName}</TableCell>
                    <TableCell>
                      <Checkbox
                        type="checkbox"
                        checked={user.isAdminDoctor}
                        disabled
                      />
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        type="checkbox"
                        checked={user.isSuperAdmin}
                        disabled
                      />
                    </TableCell>
                    <TableCell>
                      <Checkbox type="checkbox" checked={isNurse} disabled />
                    </TableCell>
                    <TableCell>
                      <Checkbox type="checkbox" checked={isManager} disabled />
                    </TableCell>
                    <TableCell>
                      <Checkbox type="checkbox" checked={isAnalyze} disabled />
                    </TableCell>
                    <TableCell>{user.type}</TableCell>
                    {/* <TableCell>{user.field}</TableCell> */}
                    <TableCell>
                      <IconButton onClick={() => handleEditConsultant(user)}>
                        <Edit size={14} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </tbody>
          </Table>
        </TableWrapper>
      </PageContainer>

      <UserManagementModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveModal}
      />

      <EditUserManagementModal
        isOpen={isEditModalOpen}
        onClose={handleCloseEditModal}
        onSave={handleUpdateConsultant}
        consultantData={editingConsultant}
      />
    </Layout>
  );
};

export default UserManagementPage;
